module.exports = __webpack_public_path__ + "img/footer_ic_number.d1cc1df5.svg";